<article class="container">
    <section class="filtersContainer">
        <app-opportunities-main-filters></app-opportunities-main-filters>

        <app-additional-filters
            [config]="additionalFiltersConfig()"
            [readonlyFields]="readonlyFields()"
            class="filter"
        ></app-additional-filters>

        <div class="clearFilters">
            <button class="tertiary-btn" [disabled]="disabledClearFiltersBtn" (click)="onClearAllFilters()">
                Clear filters
            </button>
        </div>
    </section>
</article>
